$(document).ready(function () {
  const tabArticleCache = {};

  function updateBlogTitles($container) {
  $container.find('.blog-title').each(function() {
    const $title = $(this);
    let category = $title.data('category');
    const blogTitle = $title.data('blog');

    if (!category) {
      const articleUrl = $title.closest('.blog-articles__article').find('a[href^="/blogs/"]').attr('href');
      if (articleUrl) {
        const urlParts = articleUrl.split('/');
        if (urlParts.length >= 3) {
          category = urlParts[2];
        }
      }
    }

    if (category) {
      category = denormalizeCategory(category);
      $title.text(category.charAt(0).toUpperCase() + category.slice(1));
    }
  });
}

function denormalizeCategory(slug) {
  return slug
    .replace(/aa/g, 'å')
    .replace(/ae/g, 'æ')
    .replace(/oe/g, 'ø')
    .replace(/-/g, ' & ');
}


  function ensurePagination(callback) {
    if (typeof $.fn.pagination !== "undefined") {
      callback();
    } else {
      setTimeout(() => ensurePagination(callback), 100);
    }
  }

  function cacheOriginalArticles() {
    $(".tab-content").each(function () {
      const tabId = $(this).attr("id");
      const $articles = $(this).find(".blog-articles__article");
      tabArticleCache[tabId] = $articles.toArray();
    });
  }

  function initializePagination() {
    const activeTabId = $(".tab-content.active").attr("id");
    const paginationContainerSelector = `#${activeTabId} #pagination-container, #${activeTabId} [id^="pagination-container-"]`;
    const category = $("#blog-list-wrapper").attr("data-category");

    let allArticles = (tabArticleCache[activeTabId] || [])
      .filter((el) => $(el).data("category") === category);

    // Sort by published date  if it's the 'All tab' tab
    if (activeTabId === "tab-all") {
      allArticles = allArticles.sort((a, b) => {
        const aTime = parseInt($(a).data("published-at"), 10);
        const bTime = parseInt($(b).data("published-at"), 10);
        return bTime - aTime;
      });
    }

    const itemsPerPage = 11;
    $(paginationContainerSelector).empty();

    if (allArticles.length === 0) return;

    function getFormattedHeading() {
      const category = $("#blog-list-wrapper").data("category");
      const pathParts = window.location.pathname.split("/").filter(Boolean);
      const lastPart = pathParts[pathParts.length - 1];
      const categoryLabel = category === "recipe" ? "recipe" : "artículos";

      if (lastPart === category) {
        return `Todos los ${categoryLabel}`;
      }

      const capitalized = lastPart.charAt(0).toUpperCase() + lastPart.slice(1);
      return `Todos los ${categoryLabel} On ${capitalized}`;
    }

    function simpleTemplating(data) {
      const headingText = getFormattedHeading();
      const html = data.map((item, index) => {
        const liHtml = `<li class="blog-articles__article article">${$(item).html()}</li>`;
        return index === 1 ? `${liHtml}<h2 class="articles-heading">${headingText}</h2>` : liHtml;
      }).join("");

      const $temp = $('<div>').html(html);
      updateBlogTitles($temp);
      return $temp.html();
    }

    $(paginationContainerSelector).pagination({
      dataSource: allArticles,
      pageSize: itemsPerPage,
      showPrevious: true,
      showNext: true,
      prevText: "<",
      nextText: ">",
      callback: function (data, pagination) {
        const html = simpleTemplating(data);
        $(`#${activeTabId} .blog-articles`).html(html);

        if (pagination.pageNumber !== 1) {
          $("html, body").animate(
            {
              scrollTop: $('body').offset().top - 100,
            },
            500
          );
        }
      },
    });
  }

  function updateCategory(category, suppressTabTrigger = false) {
    $("#blog-list-wrapper").attr("data-category", category);
    $(".category-button").removeClass("active");
    $(`.category-button[data-category="${category}"]`).addClass("active");

    if (!suppressTabTrigger) {
      const $activeVisibleTab = $(".tab-button.active:visible");
      if ($activeVisibleTab.length > 0) {
        $activeVisibleTab.trigger("click");
      } else {
        $(".tab-button:visible").first().trigger("click");
      }
    }
  }

  $(".tab-button").click(function (e) {
    e.preventDefault();
    const tabId = $(this).data("tab");

    $(".tab-button").removeClass("active");
    $(this).addClass("active");

    $(".tab-content").removeClass("active").addClass("hidden");
    const $activeTab = $("#" + tabId).addClass("active").removeClass("hidden");

    updateBlogTitles($activeTab);

    if (tabId !== "tab-all") {
      const blogHandle = tabId.replace("tab-", "");
      history.pushState(null, null, `/blogs/${blogHandle}`);
    } else {
      const blogHandle = $("#blog-list-wrapper").data("category");
      history.pushState(null, null, `/blogs/${blogHandle}`);
    }

    ensurePagination(initializePagination);
  });

  $(".category-button").click(function () {
    const selectedCategory = $(this).data("category");
    updateCategory(selectedCategory);
  });

  function loadInitialTab() {
    const $wrapper = $("#blog-list-wrapper");
    const currentCategory = $wrapper.data("category");
    const currentPath = window.location.pathname;
    const pathParts = currentPath.split("/").filter(Boolean);
    const blogHandleFromUrl = pathParts.length >= 2 ? pathParts[1] : null;

    let tabToActivate = "tab-all";

    if (blogHandleFromUrl) {
      const $matchingTab = $(`.tab-content[id="tab-${blogHandleFromUrl}"]`);
      const blogCategory = $matchingTab.data("category");
      if (blogCategory === currentCategory) {
        tabToActivate = `tab-${blogHandleFromUrl}`;
      }
    }

    updateCategory(currentCategory, true);

    $(".tab-button").removeClass("active");
    $(`.tab-button[data-tab="${tabToActivate}"]`).addClass("active");

    $(".tab-content").removeClass("active").addClass("hidden");
    const $activeTab = $("#" + tabToActivate).addClass("active").removeClass("hidden");

    updateBlogTitles($activeTab);

    ensurePagination(initializePagination);
  }

  ensurePagination(() => {
    cacheOriginalArticles();
    loadInitialTab();
  });
});
